import React, { useState, useEffect } from "react";

const popupStyle = (x, y) => ({
  position: "fixed",
  top: y,
  left: x,
  background: "#fff",
  border: "1px solid #ccc",
  borderRadius: 8,
  boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
  padding: 16,
  zIndex: 10000,
  minWidth: 200,
});

const labelStyle = {
  fontSize: 12,
  marginBottom: 4,
  fontWeight: 500,
};

const inputStyle = {
  width: "100%",
  marginBottom: 12,
};

export const EditFromTimeReport = ({
  position,
  onClose,
  shiftData,
  allAbsenceRules = [],
  allOvertimeRules = [],
  empId,
  editIndex,
  editType,
}) => {
  const shift = shiftData;
  const employee = shift.employees.find((e) => e.employeeId === empId);

  const [localData, setLocalData] = useState({
    startTime: shift.startTime,
    endTime: shift.endTime,
    breakStartTime: "",
    breakEndTime: "",
    absenceFrom: "",
    absenceTo: "",
    absenceType: "",
    overtimeFrom: "",
    overtimeTo: "",
    overtimeType: "",
    shiftId: shift._id,
    empId: empId,
  });

  useEffect(() => {
    if (!employee) return;
    if (editType === "break" && employee.breaks?.[editIndex]) {
      const b = employee.breaks[editIndex];
      setLocalData((prev) => ({ ...prev, breakStartTime: b.from, breakEndTime: b.to }));
    } else if (editType === "absence" && employee.absences?.[editIndex]) {
      const a = employee.absences[editIndex];

      // Om det är "hela passet" eller from/to saknas → använd skiftets tider
      const from =
        a.appliesWholeShift || !a.from
          ? shift.startTime
          : a.from;

      const to =
        a.appliesWholeShift || !a.to
          ? shift.endTime
          : a.to;

      setLocalData((prev) => ({
        ...prev,
        absenceFrom: from,
        absenceTo: to,
        absenceType: a.absenceType || "",
      }));
    }
     else if (editType === "overtime" && employee.overtime?.[editIndex]) {
      const o = employee.overtime[editIndex];
      setLocalData((prev) => ({
        ...prev,
        overtimeFrom: o.from,
        overtimeTo: o.to,
        overtimeType: o.type || "",
      }));
    }
  }, [employee, editIndex, editType]);

  const validateBeforeSave = () => {
    const parse = (timeStr) => {
      if (!timeStr) return null;
      const [h, m] = timeStr.split(":").map(Number);
      return h * 60 + m;
    };


    const isInRange = (shiftStart, shiftEnd, checkStart, checkEnd) => {
      if (shiftEnd <= shiftStart) shiftEnd += 1440;
      if (checkStart < shiftStart) checkStart += 1440;
      if (checkEnd <= checkStart) checkEnd += 1440;
      return checkStart >= shiftStart && checkEnd <= shiftEnd;
    };

    const shiftStart = parse(localData.startTime);
    const shiftEnd = parse(localData.endTime);

    if (shiftStart === null || shiftEnd === null) {
      alert("Skiftets starttid och sluttid måste vara ifyllda.");
      return false;
    }

    if (editType === "break") {
      const breakStart = parse(localData.breakStartTime);
      const breakEnd = parse(localData.breakEndTime);
      if (breakStart === null || breakEnd === null) {
        alert("Både rastens start- och sluttid måste vara ifyllda.");
        return false;
      }
      if (breakEnd === breakStart) {
        alert("Rastens start- och sluttid kan inte vara samma.");
        return false;
      }
      if (!isInRange(shiftStart, shiftEnd, breakStart, breakEnd)) {
        alert("Rasten måste ligga inom skiftets tidsspann och ha en korrekt tidsintervall.");
        return false;
      }
    }

    if (editType === "absence") {
      const absStart = parse(localData.absenceFrom);
      const absEnd = parse(localData.absenceTo);
      if (absStart === null || absEnd === null) {
        alert("Både frånvarons start- och sluttid måste vara ifyllda.");
        return false;
      }
      if (absEnd === absStart) {
        alert("Frånvarons start- och sluttid kan inte vara samma.");
        return false;
      }
      if (!isInRange(shiftStart, shiftEnd, absStart, absEnd)) {
        alert("Frånvaron måste ligga inom skiftets tidsspann och ha en korrekt tidsintervall.");
        return false;
      }
    }

    return true;
  };

  const handleChange = (key, value) => {
    setLocalData((prev) => ({ ...prev, [key]: value }));
  };

  const handleSave = () => {
    if (!validateBeforeSave()) return;
    onClose({ ...localData, empId, shiftId: shift._id, index: editIndex });
  };

  const handleRemove = () => {
    const resetFields = {
      shiftId: shift._id,
      empId,
      index: editIndex,
    };
    if (editType === "absence") {
      onClose({ ...resetFields, absenceFrom: "", absenceTo: "", absenceType: "" });
    } else if (editType === "overtime") {
      onClose({ ...resetFields, overtimeFrom: "", overtimeTo: "", overtimeType: "" });
    } else if (editType === "break") {
      onClose({ ...resetFields, breakStartTime: "", breakEndTime: "", disableBreakTime: true });
    } else {
      onClose(null);
    }
  };




  return (
    <div style={popupStyle(position.x, position.y)}>
      {editType === "shift" && (
        <>
          <div style={labelStyle}>Starttid</div>
          <input type="time" value={localData.startTime} onChange={(e) => handleChange("startTime", e.target.value)} style={inputStyle} />
          <div style={labelStyle}>Sluttid</div>
          <input type="time" value={localData.endTime} onChange={(e) => handleChange("endTime", e.target.value)} style={inputStyle} />
        </>
      )}

      {editType === "break" && (
        <>
          <div style={labelStyle}>Rast start</div>
          <input type="time" value={localData.breakStartTime} onChange={(e) => handleChange("breakStartTime", e.target.value)} style={inputStyle} />
          <div style={labelStyle}>Rast slut</div>
          <input type="time" value={localData.breakEndTime} onChange={(e) => handleChange("breakEndTime", e.target.value)} style={inputStyle} />
        </>
      )}

      {editType === "absence" && (
        <>
          <div style={labelStyle}>Frånvaro start</div>
          <input type="time" value={localData.absenceFrom} onChange={(e) => handleChange("absenceFrom", e.target.value)} style={inputStyle} />
          <div style={labelStyle}>Frånvaro slut</div>
          <input type="time" value={localData.absenceTo} onChange={(e) => handleChange("absenceTo", e.target.value)} style={inputStyle} />
          <div style={labelStyle}>Typ</div>
          <select value={localData.absenceType} onChange={(e) => handleChange("absenceType", e.target.value)} style={inputStyle}>
            <option value="">Välj typ</option>
            {allAbsenceRules.map((r) => (
              <option key={r._id} value={r._id}>{r.name}</option>
            ))}
          </select>
        </>
      )}

      {editType === "overtime" && (
        <>
          <div style={labelStyle}>Övertid från</div>
          <input type="time" value={localData.overtimeFrom} onChange={(e) => handleChange("overtimeFrom", e.target.value)} style={inputStyle} />
          <div style={labelStyle}>Övertid till</div>
          <input type="time" value={localData.overtimeTo} onChange={(e) => handleChange("overtimeTo", e.target.value)} style={inputStyle} />
          <div style={labelStyle}>Typ</div>
          <select value={String(localData.overtimeType || "")} onChange={(e) => handleChange("overtimeType", e.target.value)} style={inputStyle}>
            <option value="">Välj typ</option>
            {allOvertimeRules.map((r) => (
              <option key={r._id} value={String(r._id)}>{r.name}</option>
            ))}
          </select>
        </>
      )}

<div style={{ display: "flex", justifyContent: "flex-end", gap: "6px", marginTop: 12 }}>
  <button
    onClick={() => onClose(null)}
    style={{
      backgroundColor: "#6c757d",
      color: "#fff",
      border: "none",
      padding: "4px 8px",
      borderRadius: "4px",
      fontSize: "13px",
      cursor: "pointer"
    }}
  >
    Avbryt
  </button>
  <button
    onClick={handleRemove}
    style={{
      backgroundColor: "#c62828",  // mörkare röd
      color: "#fff",
      border: "none",
      padding: "4px 8px",
      borderRadius: "4px",
      fontSize: "13px",
      cursor: "pointer"
    }}
  >
    Ta bort
  </button>
  <button
    onClick={handleSave}
    style={{
       backgroundColor: "#6CA4BC",  // lite mörkare ljusblå
      color: "#fff",
      border: "none",
      padding: "4px 8px",
      borderRadius: "4px",
      fontSize: "13px",
      cursor: "pointer"
    }}
  >
    Spara
  </button>
</div>


    </div>
  );
};

export default EditFromTimeReport;
